export enum CampaignTemplate {
  Zero = '0',
  One = '1',
  Two = '2',
  Three = '3'
}
